import { createContext, useState } from "react";

export const RefreshContext = createContext(null);

export const RefreshContextProvider = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshData = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <RefreshContext.Provider
      value={{
        refreshKey,
        refreshData
      }}>
      {children}
    </RefreshContext.Provider>
  );
}; 